import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsCompanyViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map